/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import style from './tabs.module.scss';
import map from 'lodash-es/map';
import { Tab, Tabs } from '@mui/material';
import { CategoryId } from 'store/types';
import cx from 'classnames';

export type TabsProps<T_val> = {
  className?: string;
  groupName: string;
  defaultValue?: string;
  variants: {
    id: T_val;
    value: T_val;
    text: string;
  }[];
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    newValue: T_val
  ) => void;
};

export default function TabsComponent<T_val extends CategoryId>(
  props: TabsProps<T_val>
) {
  const [value, setValue] = useState(props.defaultValue || 'Фотографии');

  return (
    <Tabs
      value={value}
      className={cx(style.container, props.className)}
      onChange={(event, newValue) => {
        props?.onChange && props.onChange(event, newValue);
        setValue(newValue);
      }}
      textColor="primary"
      indicatorColor="primary"
    >
      {map(props.variants, (v) => {
        return <Tab value={v.id} label={v.text} key={v.id} />;
      })}
    </Tabs>
  );
}
